module.exports = __webpack_public_path__ + "img/pdficon.18f5a76a.svg";